module.exports = __webpack_public_path__ + "img/rule.eee5ebe2.png";